import React from 'react';

/** Engine sync direction coverage for Already-mapped rows. */
export type MappingCoverage = 'both' | 'emr_to_ghl' | 'ghl_to_emr' | 'unknown' | string | null | undefined;

const VIEW: Record<string, { label: string; title: string; fg: string; bg: string }> = {
    both: {
        label: 'Fully mapped · Advital ↔ EMR',
        title: 'Mapped in both directions — sync works Advital → EMR and EMR → Advital.',
        fg: '#0F7A5F',
        bg: '#E3F5EE',
    },
    emr_to_ghl: {
        label: 'EMR → Advital',
        title: 'Partial mapping — only EMR → Advital. Advital → EMR is missing.',
        fg: '#9A6700',
        bg: '#FFF4D6',
    },
    ghl_to_emr: {
        label: 'Advital → EMR',
        title: 'Partial mapping — only Advital → EMR. EMR → Advital is missing.',
        fg: '#9A6700',
        bg: '#FFF4D6',
    },
    unknown: {
        label: 'Already mapped',
        title: 'Mapped in the engine; direction coverage could not be determined.',
        fg: '#5A6473',
        bg: '#EEF1F5',
    },
};

/** Pill showing whether an engine mapping is full (↔) or one-way. */
export const MappingCoverageBadge: React.FC<{ coverage?: MappingCoverage }> = ({ coverage }) => {
    const key = coverage && VIEW[coverage] ? coverage : 'unknown';
    const v = VIEW[key];
    return (
        <span
            title={v.title}
            className="text-[11px] font-bold px-[10px] py-[3px] rounded-full whitespace-nowrap"
            style={{ background: v.bg, color: v.fg }}
        >
            {v.label}
        </span>
    );
};

/** Center connector icon matching the mapping direction (row is EMR left → Advital right). */
export const MappingCoverageArrow: React.FC<{ coverage?: MappingCoverage; className?: string }> = ({
    coverage,
    className = 'text-mapper-muted-6',
}) => {
    if (coverage === 'both') {
        return (
            <div className={`flex justify-center ${className}`} title="Fully mapped · Advital ↔ EMR">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M8 12h8M5 12l3-3M5 12l3 3M19 12l-3-3M19 12l-3 3" />
                </svg>
            </div>
        );
    }
    if (coverage === 'ghl_to_emr') {
        // Advital (right) → EMR (left): point left
        return (
            <div className={`flex justify-center ${className}`} title="Advital → EMR only">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M19 12H5M11 6l-6 6 6 6" />
                </svg>
            </div>
        );
    }
    // Default / emr_to_ghl: EMR (left) → Advital (right)
    return (
        <div className={`flex justify-center ${className}`} title={coverage === 'emr_to_ghl' ? 'EMR → Advital only' : undefined}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 12h14M13 6l6 6-6 6" />
            </svg>
        </div>
    );
};
